import { WrappedUIElement } from "../../../../misc/ui";
export class BucketUI {
    constructor(color, label) {
        this._color = new BucketUIColorContainer(color);
        this._label = new BucketUILabelContainer(label);
    }
    get isEnabled() {
        return this._color.isEnabled && this._label.isEnabled;
    }
    get color() {
        return this._color.value;
    }
    get label() {
        return this._label.value;
    }
    toggle() {
        if (this.isEnabled)
            this.disable();
        else
            this.enable();
    }
    enable() {
        this._color.enable();
        this._label.enable();
    }
    disable() {
        this._color.disable();
        this._label.disable();
    }
}
class BucketUIColorContainer extends WrappedUIElement {
    constructor(element) {
        super(element);
    }
    get isEnabled() {
        return !this.element.hasClass('desaturated');
    }
    get value() {
        return this.element.css('background-color');
    }
    enable() {
        this.element.removeClass('desaturated');
    }
    disable() {
        this.element.addClass('desaturated');
    }
}
class BucketUILabelContainer extends WrappedUIElement {
    constructor(element) {
        super(element);
    }
    get isEnabled() {
        return !this.element.hasClass('crossed-out');
    }
    get value() {
        return this.element.attr('data-name');
    }
    enable() {
        this.element.removeClass('crossed-out');
    }
    disable() {
        this.element.addClass('crossed-out');
    }
}
